import {reduxForm, Field, formValueSelector, change} from 'redux-form'
import styles from './style.css'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import SettingFieldWithIcon from 'components/Fields/ReduxForm/SettingFieldWithIcon'
import {
  onClickCancel,
  deleteTaxRequest
} from 'actions/library/tax'
import {connect} from 'react-redux'

const validate = (values) => {
  const errors = {}
  if ((!values.name) || (values.name.trim() === '')) {
    errors.name = 'Please enter a value'
  }
  if (!values.amount) {
    errors.amount = 'Please enter a value'
  } else if (values.amount < 1) {
    errors.amount = 'Please enter a value greater than or equal 1'
  } else if (values.amount > 100) {
    errors.amount = 'Please input tax less 100%'
  }
  return errors
}

class TaxForm extends React.Component {
  render () {
    let {handleSubmit, isSubmittingForm} = this.props
    return (
      <form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <div className={`${styles['field-wrapper']} tax-field-wrapper`}>
          <div className={styles.title}>
            Tax Information
          </div>
          <div className='row'>
            <div className='col-sm-12'>
              <div className='col-sm-6 col-md-6 no-padding'>
                <Field
                  component={SettingField}
                  name='name'
                  className='form-control'
                  placeholder='Name'
                />
              </div>
              <div className='col-sm-6 col-md-6'>
                <Field
                  component={SettingFieldWithIcon}
                  name='amount'
                  icon='%'
                  className='form-control'
                  placeholder='Amount'
                  positiveNumberOnly
                  maxFractionDigits={3}
                  />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          {this.props.tax.id &&
          <span className='pull-left'>
            <button className='btn btn-danger'
              onClick={this._onClickDelete}
              type='button'
              disabled={isSubmittingForm}>
              <i className='fa fa-trash' />
            </button>
          </span>
        }
          <span className='pull-right'>
            <button
              type='button'
              className={`btn btn-default ${styles['btn-cancel']}`}
              onClick={this._onClickCancel}
              disabled={isSubmittingForm}>
              Cancel
            </button>
            {this.props.outlets.length > 1 && !this.props.tax.id &&
              <button
                type='button'
                className={`btn btn-primary mr-10px`}
                onClick={handleSubmit(this._onSubmitToAllOutlet)}
                disabled={isSubmittingForm}>
                Save to All Outlets
              </button>
            }
            <button
              className={`btn btn-primary ${styles['btn-save']}`}
              onClick={handleSubmit(this._onSubmit)}
              type='button'
              disabled={isSubmittingForm}>
              Save
            </button>
          </span>
        </div>
      </form>
    )
  }

  _onChangeAmount = (event, nextVal, prevVal) => {
    if (!isNaN(nextVal)) {
      this.props.dispatch(change('taxForm', 'amount', nextVal))
    }
  }

  _onClickCancel = (event) => {
    this.props.dispatch(onClickCancel())
    event.preventDefault()
    event.stopPropagation()
  }

  _onClickDelete = (event) => {
    const {dispatch, taxDetail} = this.props
    dispatch(deleteTaxRequest(taxDetail))
    event.preventDefault()
    event.stopPropagation()
  }

  _onSubmitToAllOutlet = (values) => {
    this.props.onSubmit({...values, action: 'saveToAllOutlet'})
  }

  _onSubmit = (values) => {
    this.props.onSubmit({...values, action: 'save'})
  }
}

const selector = formValueSelector('tax')

const mapForm = {
  form: 'tax',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

function mapStateToProps (state) {
  const {taxes, taxDetail, outlets, isSubmittingForm} = state.library.tax
  return {
    taxes,
    taxDetail,
    outlets,
    tax: {id: selector(state, 'id')},
    data: {
      form: state.form
    },
    isSubmittingForm
  }
}

export default connect(mapStateToProps)(reduxForm(mapForm)(TaxForm))



// WEBPACK FOOTER //
// ./app/pages/Library/Tax/TaxDetail/TaxForm.js